import { $http } from "@/utils/http";
import { SET_PAYMENT_METHODS_LIST, SET_PAYMENT_METHODS_LIST_LOADING } from "../mutation-types";

import { GET_PAYMENT_METHODS_LIST } from "../action-types";

const state = {
    paymentMethodsList: null,
    paymentMethodsListLoading: false,
};

const getters = {
    paymentMethodsList: state => state.paymentMethodsList,
    paymentMethodsListLoading: state => state.paymentMethodsListLoading,
};

const actions = {
    [GET_PAYMENT_METHODS_LIST]: async ({ commit }) => {
        commit(SET_PAYMENT_METHODS_LIST_LOADING, true);
        // commit(RESET_PRODUCT);
        try {
            const response = await $http.get(`v1/payment-methods`);
            commit(SET_PAYMENT_METHODS_LIST, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_PAYMENT_METHODS_LIST_LOADING, false);
        }
    },
};
//
const mutations = {
    [SET_PAYMENT_METHODS_LIST](state, list) {
        state.paymentMethodsList = list;
    },
    [SET_PAYMENT_METHODS_LIST_LOADING](state, status) {
        state.paymentMethodsListLoading = status;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
